import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36238f3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=36238f3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36238f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36238f3e')) {
      api.createRecord('36238f3e', component.options)
    } else {
      api.reload('36238f3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36238f3e&scoped=true", function () {
      api.rerender('36238f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/index.vue"
export default component.exports